$(document).ready(function(e) {
  
  	var qty = $('.qty').val();

    $('.minus-qty').click(function(){
        if(qty > 1) {
            qty--;
            $('.qty').val(qty);
        }
        return false;
    });

    $('.plus-qty').on('click',function() {
        qty++;
        $('.qty').val(qty);

        return false;
    });
	 
	$('#category h2').click(function(e) {
        $(this).siblings('.nav').toggle();
    });
	
	/* Flexslider */
	$('#carousel').flexslider({
    	animation: "slide",
    	controlNav: false,
    	animationLoop: false,
    	slideshow: false,
    	itemWidth: 100,
    	itemMargin: 5,
    	asNavFor: '#slider'
  	});
   
  	$('#slider').flexslider({
    	animation: "slide",
    	controlNav: false,
    	animationLoop: false,
    	slideshow: false,
    	sync: "#carousel"
  	});
  
  if( GetURLParameter('view') == 'list' ) {
    $('.grid').removeClass('active');
  	$('.list').addClass('active');
  }
  
  $('.dropdown-menu li').click(function(e){
  	$(this).siblings('button').val();
  });
  
	
});

function GetSortParameter(param){
	
}

function GetURLParameter(sParam)
{
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) 
        {
            return sParameterName[1];
        }
    }
}